import React from 'react';
import cn from 'classnames';

export const PageHeader: React.FC<{
  left: React.ReactNode;
  center?: React.ReactNode;
  right?: React.ReactNode;
  className?: string;
  contentClassName?: string;
  leftClassName?: string;
  centerClassName?: string;
  rightClassName?: string;
  dataTestId?: string;
}> = ({
  left,
  center,
  right,
  className,
  contentClassName,
  leftClassName,
  centerClassName,
  rightClassName,
  dataTestId,
}) => {
  return (
    <div
      data-testid={dataTestId}
      className={cn(
        'px-10 py-5 bg-white shadow-hard sticky top-0 w-full z-cover',
        className,
      )}
    >
      <div
        className={cn(
          'flex w-full flex-wrap items-center justify-between gap-x-8 gap-y-4',
          contentClassName,
        )}
      >
        <div className={cn('flex min-w-0 items-center gap-6', leftClassName)}>
          {left}
        </div>
        {center && (
          <div
            className={cn(
              'flex min-w-0 flex-wrap items-center justify-center gap-4 overflow-hidden',
              centerClassName,
            )}
          >
            {center}
          </div>
        )}
        {right && (
          <div
            className={cn(
              'flex min-w-0 flex-wrap items-center justify-end gap-4 overflow-hidden',
              rightClassName,
            )}
          >
            {right}
          </div>
        )}
      </div>
    </div>
  );
};
